// Import components
import Header from '../Header';
import Footer from '../Footer';

function PagesLayout({ LOGO_WIDTH, ICON_WIDTH, children }) {
    return (
        <>
            <Header LOGO_WIDTH={LOGO_WIDTH} ICON_WIDTH={ICON_WIDTH} />
            {children}
            <Footer LOGO_WIDTH={LOGO_WIDTH} ICON_WIDTH={ICON_WIDTH} />
        </>
    );
}

export default PagesLayout;
